import styled, { css } from 'styled-components'
// themes
import { colors } from 'themes/index'
// views
import { ErrorMessageWrapper } from 'components/UI/ErrorMessage'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  ${ErrorMessageWrapper} {
    bottom: -10px;
  }
`

export const Button = styled.div<{ disabled: boolean }>`
  color: ${colors.blue500};
  display: flex;
  gap: 8px;
  cursor: pointer;
  padding-left: 24px;

  ${({ disabled }) =>
    disabled &&
    css`
      cursor: default;
      color: ${colors.gray300};
      pointer-events: none;
    `};

  &:hover {
    opacity: 0.8;
  }
`

export const SwitchGroup = styled.div`
  padding-left: 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const ErrorMessage = styled.div`
  color: ${colors.red300};
  font-size: 0.75rem;
  text-align: left;
  margin-left: 24px;
  margin-top: -8px;
`
